import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import companiesReducer from "../features/companies/companiesSlice";
import companyUsersReducer from "../features/companyUsers/companyUsersSlice";
import deviceAssignmentsReducer from "../features/deviceAssignments/deviceAssignmentsSlice";
import companyDevicesReducer from "../features/companyDevices/companyDevicesSlice";
import devicesReducer from "../features/devices/devicesSlice";
import ticketsReducer from "../features/tickets/ticketsSlice";
import auditLogReducer from "../features/auditLog/auditLogSlice";
import offlineReducer from "../features/offline/offlineSlice";
import deviceConfigReducer from "../features/deviceConfig/deviceConfigSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    companies: companiesReducer,
    companyUsers: companyUsersReducer,
    deviceAssignments: deviceAssignmentsReducer,
    companyDevices: companyDevicesReducer,
    devices: devicesReducer,
    tickets: ticketsReducer,
    auditLog: auditLogReducer,
    offline: offlineReducer,
    deviceConfig: deviceConfigReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});
